export function generateAdminURL(pathType, id, title) {
  const slug = title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove non-word characters
    .replace(/\s+/g, '-')     // Replace spaces with dashes
    .replace(/-+/g, '-');     // Collapse multiple dashes

  return `/${pathType}/${id}/${slug}`;
}